import { KEYS, load, save, remove } from "@/lib/storage";

// Wraps saved-game persistence with a schema version so future migrations are safe.
const SCHEMA_VERSION = 1;

export function loadSavedGame() {
  const data = load(KEYS.savedGame);
  if (!data) return null;
  if (data.schemaVersion !== SCHEMA_VERSION) return null;
  return data;
}

export function saveGame({ state, mode, difficulty, rulesetId, side }) {
  const payload = {
    schemaVersion: SCHEMA_VERSION,
    savedAt: Date.now(),
    mode,           // 'single' | 'local'
    difficulty,     // for 'single'
    rulesetId,
    side,           // human side for 'single' ('A' or 'B')
    state,
  };
  save(KEYS.savedGame, payload);
  return payload;
}

export function clearSavedGame() {
  remove(KEYS.savedGame);
}

export function hasSavedGame() {
  const g = loadSavedGame();
  return !!(g && g.state && g.state.status === "ACTIVE");
}
